var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"container"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":require("./loading.png"),"alt":"加载"}}),_c('div',{staticClass:"outer"}),_c('div',{staticClass:"inner"})])
}]

export { render, staticRenderFns }